export const GET_WARBOX_MESSAGES_BY_CONVERSATION =
    'GET_WARBOX_MESSAGES_BY_CONVERSATION';
export const GET_WARBOX_GALLERY_MESSAGES_BY_CONVERSATION =
    'GET_WARBOX_GALLERY_MESSAGES_BY_CONVERSATION';
export const GET_WARBOX_MESSAGES = 'GET_WARBOX_MESSAGES';
export const ADD_WARBOX_MESSAGE = 'ADD_WARBOX_MESSAGE';
export const UPSERT_WARBOX_MESSAGE = 'UPSERT_WARBOX_MESSAGE';
export const DELETE_WARBOX_MESSAGE = 'DELETE_WARBOX_MESSAGE';
export const CLEAR_WARBOX_CONVERSATION_MESSAGES =
    'CLEAR_WARBOX_CONVERSATION_MESSAGES';
export const SET_GALLERY_LOADING = 'SET_GALLERY_LOADING';
